import React from "react";
import { IoLogoWhatsapp } from "react-icons/io";
import { Link } from "react-router-dom";

// https://wa.me/447782556546?text=I'm%20interested%20in%20Fusion%20Products

const ChatIcon = () => {
  return (
    <Link
      to="https://wa.me/447782556546?text=I'm%20interested%20in%20Fusion%20Products"
      target="_blank"
      rel="noopener noreferrer"
      className="animate__animated  animate__pulse animate__infinite shadow-lg cursor-pointer
                 bg-[#25D366] hover:bg-[#173303] text-white p-3 rounded-full
                 bottom-5 left-6 fixed
                 md:bottom-6 md:left-[30px]
                 lg:bottom-12 lg:left-[50px]"
    >
      <IoLogoWhatsapp size="30px" className="text-white hover:text-[#25D366]" />
    </Link>
  );
};

export default ChatIcon;
